import { createHead } from '@unhead/vue/client'
import i18n from './i18n'
import getEnvironment from '@/utils/env'
import { getIntlLocales } from '@/utils/format'

const env = getEnvironment()

const unhead = createHead({
  init: [
    {
      titleTemplate: (title) => {
        const prefix =
          env != null && env.id !== 'production'
            ? `[${env.name?.substring(0, 2).toLocaleUpperCase(getIntlLocales())}] `
            : ''
        return title ? `${prefix}${title} | Amili` : `${prefix}Amili`
      },
      htmlAttrs: {
        lang: () => i18n.global.locale.value,
      },
      link: [
        {
          rel: 'icon',
          href: env != null && env.id !== 'production' ? `/favicon-${env.id}.png` : '/favicon.ico',
          key: 'favicon',
        },
      ],
    },
  ],
})

export default unhead
